/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum UrlType {
  Telegram = 0,
  Instagram = 1,
  WhatsApp = 2,
  Facebook = 3,
  LinkedIn = 4,
  Twitter = 5,
  YouTube = 6,
  WebSite = 7,
  GoogleLink = 8,
  WazeLink = 9,
  NeshanLink = 10,
  MapIrLink = 11
}
